<template>
    <div class="j-address-wrap" v-if="type === 'select'">
        <el-cascader v-bind="$attrs" :options="options" v-model="selected" :props="{ emitPath }" :separator="textSeparator" @change="changeEvent" :clearable="clearable" />
    </div>
    <span v-else>{{textHandle().join(textSeparator)}}</span>
</template>

<script>
    // import { regionData, codeToText as CodeToText } from 'element-china-area-data' // 数据格式  [ "11", "1101", "110101" ]  [ "北京市", "市辖区", "东城区" ]
    import { regionData, codeToText as CodeToText } from './data/ChinaAreaData' // (后端数据库一致)数据格式  [ "110000", "110100", "110101" ]   [ "北京市", "北京市", "东城区" ]
    export default {
        name: "JAddress",
        props: {
            emitPath: { // 仅显示最后一级
              type: Boolean,
              default: true
            },
            clearable: {
              type: Boolean,
              default: true
            },
            value: {
                type: [Array, String]
            },
            type: {
                type: String,
                default: 'select'
            },
            textSeparator: {
                type: String,
                default: '/'
            },
            separator: {
                type: String,
                default: ','
            },
            valueType: {
                type: String,
                default: 'Array'
            }
        },
        data() {
            return {
                selected: [],
                options: regionData
            }
        },
        created () {
          this.updateData(this.value)
        },
        methods: {
            updateData (value) {
                if (this.emitPath) {
                    if (this.valueType === 'Array') this.selected = value || []
                    else this.selected = value ? value.split(this.separator) : []
                } else {
                    if (this.valueType === 'Array' && Array.isArray(value)) this.selected = value.join(this.separator)
                    else this.selected = value
                }
            },
            textHandle () {
                if (this.emitPath) {
                    return this.selected.map(item => (CodeToText[item] || item)) || []
                } else {
                    if (this.valueType === 'Array' && Array.isArray(this.selected)) return this.selected.map(item => (CodeToText[item] || item)) || []
                    else return [CodeToText[this.selected] || this.selected]
                }
            },
            changeEvent (v) {
                if (this.emitPath) {
                    if (this.valueType === 'Array') {
                        this.$emit('input', v)
                    } else {
                        this.$emit('input', v.length > 0 ? v.join(this.separator) : '')
                    }
                    this.$emit('change', {
                        code: v,
                        text: this.textHandle()
                    })
                } else { // 适用于 emitPath 为false
                    if (this.valueType === 'Array') {
                        this.$emit('input', [v])
                    } else {
                        this.$emit('input', v)
                    }
                    this.$emit('change', {
                        code: v,
                        text: CodeToText[v]
                    })
                }
            }
        },
        watch: { value (nv) { this.updateData(nv) } }
    }
</script>

<style lang="scss">
    .j-address-wrap {
        display: flex;
        width: 100%;
      .el-cascader {
        width: 100%;
      }
    }
</style>
